import React, { useEffect } from "react";
import Modal from '../../common/modal';
import api from "../../common/api";
import { motion } from "framer-motion";

const Tutorial = ({ subLink }) => {
    const getplanInfo = async () => {
        try {
            const response = await api("get", "/api/user/appleid", null);
            if (response.message === "401") {
                localStorage.clear();
                window.location.href = '/login';
            } else {
                const ad = document.getElementById("appleid");
                if (ad) ad.innerHTML = response.data;
            }
        } catch (error) {
            const ad = document.getElementById("appleid");
            if (!error || !error.data) {
                ad.innerHTML = "网络错误，无法获取Apple ID";
            }
        }
    };

    useEffect(() => {
        getplanInfo()
    }, []);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.5
            }
        }
    };

    return (
        <Modal target={"ios"} title={"iOS 使用教程"}>
            <main className="py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
                <div className="max-w-7xl mx-auto">
                    <motion.section
                        className="mb-12"
                        initial="hidden"
                        animate="visible"
                        variants={containerVariants}
                    >
                        <motion.p
                            className="text-2xl text-gray-800 mb-12 text-center font-medium"
                            variants={itemVariants}
                        >
                            按照以下步骤在 iOS 上设置并使用
                        </motion.p>
                        <div className="grid grid-cols-1 gap-8 mb-12">
                            <motion.div
                                className="bg-gradient-to-r from-blue-50 to-blue-100 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                                variants={itemVariants}
                            >
                                <h2 className="text-2xl font-bold mb-4 text-blue-800">共享 Apple ID</h2>
                                <div className="text-lg text-gray-700 mb-4 space-y-3">
                                    <p id="appleid" className="font-medium text-blue-600">【购买套餐后此处将显示共享Apple ID】</p>
                                    <a
                                        href="https://docs.ikuai.cc/appleid.jpg"
                                        target="_blank"
                                        className="inline-block text-blue-600 hover:text-blue-800 transition-colors duration-300"
                                    >
                                        【点我查看图文教程】
                                    </a>
                                    <div className="space-y-2 mt-4">
                                        <p className="text-red-600 font-medium">❗️登录选择其他选项不升级❗️</p>
                                        <p className="text-red-600 font-medium">❗️从商店登陆❗️</p>
                                        <p className="text-red-600 font-medium">❗️不要登陆iCloud❗️</p>
                                    </div>
                                </div>
                            </motion.div>

                            <motion.div
                                className="bg-gradient-to-r from-blue-50 to-blue-100 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                                variants={itemVariants}
                            >
                                <h2 className="text-2xl font-bold mb-4 text-blue-800">步骤 1: 下载</h2>
                                <p className="text-lg text-gray-700 mb-6">
                                    在 App Store 中下载 Shadowrocket
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    <a
                                        href="https://apps.apple.com/us/app/shadowrocket/id932747118"
                                        target="_blank"
                                        className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 shadow-md hover:shadow-lg"
                                    >
                                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                        </svg>
                                        App Store 下载
                                    </a>
                                </div>
                            </motion.div>

                            <motion.div
                                className="bg-gradient-to-r from-blue-50 to-blue-100 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                                variants={itemVariants}
                            >
                                <h2 className="text-2xl font-bold mb-4 text-blue-800">步骤 2: 安装</h2>
                                <p className="text-lg text-gray-700 mb-4">
                                    打开 Shadowrocket，点击右上角的"+"号
                                </p>
                                <div className="mt-4 p-4 bg-white rounded-lg shadow-inner">
                                    <p className="text-gray-600 italic">💡 提示：首次使用需要配置 VPN 权限</p>
                                </div>
                            </motion.div>

                            <motion.div
                                className="bg-gradient-to-r from-blue-50 to-blue-100 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                                variants={itemVariants}
                            >
                                <h2 className="text-2xl font-bold mb-4 text-blue-800">步骤 3: 导入</h2>
                                <p className="text-lg text-gray-700 mb-6">
                                    点击下方按钮一键导入节点配置
                                </p>
                                <button
                                    onClick={() => {
                                        let encodeurl = encodeURIComponent(subLink);
                                        window.location.href = `shadowrocket://add/sub://${btoa(subLink)}?remarks=${encodeURIComponent(process.env.REACT_APP_NAME)}`;
                                    }}
                                    className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl"
                                >
                                    <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                    </svg>
                                    一键导入节点
                                </button>
                            </motion.div>

                            <motion.div
                                className="bg-gradient-to-r from-blue-50 to-blue-100 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                                variants={itemVariants}
                            >
                                <h2 className="text-2xl font-bold mb-4 text-blue-800">步骤 4: 运行</h2>
                                <p className="text-lg text-gray-700 mb-4">
                                    导入后在订阅中选中，然后启动服务即可
                                </p>
                            </motion.div>
                        </div>
                    </motion.section>
                </div>
            </main>
        </Modal>
    );
};

export default Tutorial;